import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentSpecialFreightTrackingService } from './shipment-special-freight-tracking.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentSpecialFreightTrackingLoad,
  ShipmentSpecialFreightTrackingSetInitialState,
} from './shipment-special-freight-tracking.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { SpecialFreightMilestoneModel } from '../../models';
import { LinkInfoType } from '../../../../models';

export interface ShipmentSpecialFreightTrackingStateModel {
  milestones: SpecialFreightMilestoneModel[];
  linkInfoType: LinkInfoType;
  loaded: boolean;
}

const initialState: ShipmentSpecialFreightTrackingStateModel = {
  milestones: [],
  linkInfoType: null,
  loaded: false,
};

@State<ShipmentSpecialFreightTrackingStateModel>({
  name: 'shipmentSpecialFreightTracking',
  defaults: initialState,
})
@Injectable()
export class ShipmentSpecialFreightTrackingState {
  constructor(
    private shipmentSpecialFreightTrackingService: ShipmentSpecialFreightTrackingService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentSpecialFreightTrackingStateModel): ShipmentSpecialFreightTrackingStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentSpecialFreightTrackingStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getTransportMode(state: ShipmentSpecialFreightTrackingStateModel): LinkInfoType {
    return state.linkInfoType;
  }

  @Selector()
  static getMilestones(state: ShipmentSpecialFreightTrackingStateModel): SpecialFreightMilestoneModel[] {
    return state.milestones;
  }

  @Action(ShipmentSpecialFreightTrackingLoad)
  getWaybillTracking(
    ctx: StateContext<ShipmentSpecialFreightTrackingStateModel>,
    { payload }: ShipmentSpecialFreightTrackingLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentSpecialFreightTrackingService.getMilestonesData(payload).pipe(
      map(
        ({ milestones, linkInfoType }: { milestones: SpecialFreightMilestoneModel[]; linkInfoType: LinkInfoType }) => {
          ctx.patchState({ milestones, linkInfoType, loaded: true });
        },
      ),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentSpecialFreightTrackingSetInitialState)
  setInitialState(ctx: StateContext<ShipmentSpecialFreightTrackingStateModel>): void {
    ctx.setState(initialState);
  }
}
